"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var MainColorPicker_1 = __importDefault(require("./MainPicker/MainColorPicker"));
var React = __importStar(require("react"));
var Button_1 = __importDefault(require("../Button/Button"));
var tinycolor2_1 = __importDefault(require("tinycolor2"));
var localization_1 = require("@scuf/localization");
var translations_1 = __importDefault(require("./translations"));
/**
 * The ColorPicker component allows a user to select a color from a predefined palette of color swatches, or any color they would like.
 */
var ColorPicker = /** @class */ (function (_super) {
    __extends(ColorPicker, _super);
    function ColorPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (changedColor) {
            _this.setState({ currentColor: changedColor.rgb });
            return _this.props.onChange && _this.props.onChange(_this.genOutput(changedColor.rgb));
        };
        _this.resetPicker = function () {
            _this.setState({
                currentColor: _this.state.appliedColor
            });
            return _this.props.onChange && _this.props.onChange(_this.genOutput(_this.state.appliedColor));
        };
        _this.applyColor = function () {
            _this.setState({
                appliedColor: _this.state.currentColor
            });
            return _this.props.onApply && _this.props.onApply(_this.genOutput(_this.state.currentColor));
        };
        _this.genOutput = function (color) {
            var tcColor = tinycolor2_1.default(color);
            return {
                hex: tcColor.toHexString(),
                hsl: tcColor.toHslString(),
                rgb: tcColor.toRgbString()
            };
        };
        _this.state = {
            currentColor: _this.getColor()
        };
        return _this;
    }
    ColorPicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, palette = _a.palette, value = _a.value, open = _a.open, onApply = _a.onApply, onChange = _a.onChange, rest = __rest(_a, ["className", "palette", "value", "open", "onApply", "onChange"]);
        var color = this.getColor();
        var custom = className ? className : '';
        return (React.createElement(localization_1.LocalizationProvider, { translations: translations_1.default },
            React.createElement("div", __assign({}, rest, { className: "ui color-picker " + custom }),
                React.createElement(MainColorPicker_1.default, __assign({}, this.props, { palette: palette, color: color, onChange: this.onChange })),
                React.createElement(localization_1.TranslationConsumer, null, function (t) { return (React.createElement("div", { className: "button-row" },
                    React.createElement(Button_1.default, { className: "action-btn", onClick: _this.resetPicker, type: "secondary", size: "small", content: t('Reset') }),
                    React.createElement(Button_1.default, { className: "action-btn", type: "primary", size: "small", onClick: _this.applyColor, content: t('Apply') }))); }))));
    };
    ColorPicker.prototype.getColor = function () {
        if (this.props.value) {
            return tinycolor2_1.default(this.props.value).toRgb();
        }
        else if (this.state && this.state.currentColor) {
            return this.state.currentColor;
        }
        else {
            return tinycolor2_1.default(this.props.palette[0]).toRgb();
        }
    };
    ColorPicker.defaultProps = {
        palette: [
            '#EE3124', '#7EB338', '#9B59B6', '#FFC627', '#F37021', '#1792E5',
            '#F15A50', '#98C260', '#AF7AC5', '#FFD152', '#F58D4D', '#45A8EA',
            '#BE271D', '#658F2D', '#7C4792', '#CC9E1F', '#C25A1A', '#1275B7',
            '#000000', '#707070', '#808080', '#A0A0A0', '#D0D0D0', '#FFFFFF'
        ]
    };
    return ColorPicker;
}(react_1.Component));
exports.default = ColorPicker;
